module.exports = __webpack_public_path__ + "media/images/front/icon_04_arrow_wh-db65b8cfefa501732c4f79aa7812d7d9.png";